<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-8.14,802.5v-20h5.45v20H-8.14z M0.95,800.68l-1.82-1.82v-2.73l1.82,1.82l5.45-5.45l-5.45-5.45l-1.82,1.82v-2.73l1.82-1.82
	l8.18,8.18L0.95,800.68z"/>
</svg>

</template>